import React, { useEffect, useState } from "react";
import { auth, useAppContext } from "../context/AppContext";
import { IoWarningSharp } from "react-icons/io5";
import { toast } from "react-toastify";
import { useModal } from "../context/ModalContext";
import Preloader from "../components/Preloader";
import { beginPatreonLink, tierIdToName, unlinkPatreonAccount } from "../util/PatreonUtil";
import { deleteFirebaseAccount } from "../util/FirebaseUtil";
import { Link } from "react-router-dom";

const ProfilePage: React.FC = () => {
    const { isWaitingForData, patreonId, tierId, accessTier, isAdmin } = useAppContext();
    const { showModal } = useModal();

    useEffect(() => {
        document.title = "Profile | ipwd.club";
    }, []);

    const handleLinkPatreon = async () => {
        await beginPatreonLink();
    }

    const handleUnlinkPatreon = () => {
        showModal({
            title: "Confirm Patreon Unlink",
            message: "Are you sure you want to unlink your Patreon account?",
            onConfirm: () => {
              // Perform unlink logic here.
              console.log("Patreon unlink confirmed.");
              sendUnlinkPatreon();
            },
            onCancel: () => {
              console.log("Patreon unlink canceled.");
            },
        });
    }

    const sendUnlinkPatreon = async () => {
        await unlinkPatreonAccount().then((success) => {
            if (success) {
                // refresh page
                window.location.reload();
                toast.success("Patreon account unlinked");
            } else {
                toast.error("Error unlinking Patreon account");
            }
        });
    }

    const handleLogout = () => {
        auth.signOut();
    };

    const handleDeleteAccountClick = () => {
        showModal({
            title: "Confirm Account Deletion",
            message: "Are you sure you want to delete your account?.",
            onConfirm: () => {
              // Perform deletion logic here.
              console.log("Account deletion confirmed.");
              sendDeleteAccount();
            },
            onCancel: () => {
              console.log("Account deletion canceled.");
            },
        });
    }

    const sendDeleteAccount = async () => {
        // send request to our server to delete the account
        await deleteFirebaseAccount().then((success) => {
            if (success) {
                // Account deleted, now log out of Firebase
                // This will trigger the onAuthStateChanged listener in AppContext
                auth.signOut();
                toast.success("Account deleted");
            } else {
                toast.error("Error deleting account");
            }
        });
    }

    if (isWaitingForData) {
        return <Preloader message="Fetching user info..." />;
    }

    function generatePatreonLinkedJsx() {
        if (patreonId) {
            return <span className="success">Yes</span>;
        }
        return <span className="error">No</span>;
    }
    function generatePatreonTierJsx() {
        if (tierId) {
            return <span className="purple">{tierIdToName(tierId)}</span>;
        }
        return <span className="error">Not Subscribed</span>;
    }

    function generatePatreonInfoJsx() {
        const jsx: JSX.Element[] = [];
        
        jsx.push(
          <p key="patreon-linked">
            Patreon Linked: {generatePatreonLinkedJsx()}
          </p>
        );
        
        if (patreonId) {
            jsx.push(
                <p key="patreon-tier">
                    Patreon Tier: {generatePatreonTierJsx()}
                </p>
            );
        } else {
            jsx.push(
              <p key="patreon-warning" className="error">
                <IoWarningSharp /> You need to link your Patreon account to access the files.
              </p>
            );
            jsx.push(
              <button key="link-patreon" className="btn" onClick={handleLinkPatreon}>
                Link Patreon
              </button>
            );
        }

        if (patreonId && accessTier < 1) {
            jsx.push(
              <p key="patreon-tier-warning" className="error">
                <IoWarningSharp /> You need to be subscribed to the Dreaming tier or higher to access the files.
              </p>
            );
        }
        
        return jsx;
    }

    return (
        <div className="center-div">
            <h1>Profile</h1>
            <p>User: <span className="success">{auth.currentUser?.email}</span></p>
            { generatePatreonInfoJsx() }
            <p></p>
            <p style={{fontSize: "0.75em", color: "#A6A6A6", textAlign: "center"}}>
                Changes to your Patreon account may take up to a few minutes to reflect here.<br />
                If you have any issues, please contact us on Patreon or Discord.
            </p>
            <p></p>
            <button className="btn btn-logout" onClick={handleLogout}>Logout</button>
            <p></p>
            <p></p>
            {
                patreonId ? <button className="btn btn-deleteAccount" onClick={handleUnlinkPatreon}>Unlink Patreon</button> : null
            }
            <button className="btn btn-deleteAccount" onClick={handleDeleteAccountClick}>Delete Account</button>
            <p></p>
            <p></p>
            {
                isAdmin ? <div className="center-div" style={{border: "1px solid #ccc", padding: "10px"}}>
                    <Link to="/admin/serverLogs" className="btn">Server Logs</Link>
                    <Link to="/admin/userManager" className="btn">User Manager</Link>
                    <Link to="/admin/videoDataManager" className="btn">Video Data Manager</Link>
                </div>
                 : null
            }
        </div>
    );
}

export default ProfilePage;